/* eslint-disable max-len,no-irregular-whitespace,no-console,jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */
import React from 'react';
import Layout from '../../components/Layout';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import SEO from '../../components/seo';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import './style.scss';
import getCloudinary from '../../utils/getCloudinary';

const ContactPage = () => (
    <Layout id="contact-page">
        <SEO title="Contact Us" />
        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content">
            <div className="container main-container">
                <div className="columns is-centered contact-form-container is-marginless is-paddingless">
                    <div
                        className="contact-form-container__contact-info"
                        style={{
                            backgroundImage: `url("${getCloudinary().url(
                                'dashboard-uploads/sam_lisa_oil_xbcd22',
                                { height: 500, crop: 'fit', fetch_format: 'auto' },
                            )}")`,
                        }}
                    >
                        <div className="image-dimmer" />

                        <div
                            className="title is-size-4-touch is-size-3-desktop is-spaced has-text-white"
                        >
                            <span className="icon is-primary has-text-info">
                                <i className="fas fa-map-marker-alt" />
                            </span>
                            HQ Address
                        </div>
                        <div
                            className="subtitle is-size-5-touch is-size-4-desktop has-text-white"
                        >
                            {'227 Shepherd\'s Bush Road'}
                            <br />
                            Hammersmith
                            <br />
                            London
                            <br />
                            W6 7AS
                        </div>

                        <div
                            className="title is-size-4-touch is-size-3-desktop is-spaced has-text-white"
                        >
                            <span className="icon is-primary has-text-info">
                                <i className="fas fa-at" />
                            </span>
                            Email
                        </div>
                        <div
                            className="subtitle is-size-5-touch is-size-4-desktop has-text-white"
                        >
                            hello@drwatson.co.uk
                        </div>

                    </div>
                    <div className="contact-form-container__main-content">
                        <form
                            name="contact"
                            method="POST"
                            data-netlify="true"
                            className="is-full-mobile is-half-desktop is-one-third-fullhd contact-form"
                            action="/contact/submitted"

                        >
                            <div
                                className="title is-size-4-touch is-size-3-desktop is-spaced has-text-centered has-text-white"
                            >
                                Contact Us
                            </div>
                            <div
                                className="subtitle is-size-5-touch is-size-4-desktop has-text-centered has-text-white"
                            >
                                Send us a message and we will respond as fast as we can
                            </div>
                            <img
                                className="cbd-delivery-system"
                                src={getCloudinary().url(
                                    'dashboard-uploads/device-grey-horizontal_ejemci',
                                    { height: 110, crop: 'fit', fetch_format: 'auto' },
                                )}
                                alt="CBD Delivery System / White"
                            />
                            <input type="hidden" name="bot-field" />
                            <input type="hidden" name="form-name" value="contact" />

                            <div className="field">
                                <label className="label has-text-white">Name</label>
                                <div className="control">
                                    <input
                                        className="input"
                                        type="text"
                                        name="name"
                                        id="name"
                                    />
                                </div>
                            </div>

                            <div className="field">
                                <label className="label has-text-white">Email</label>
                                <div className="control has-icons-left has-icons-right">
                                    <input
                                        className="input"
                                        type="email"
                                        name="email"
                                        id="email"
                                    />
                                    <span className="icon is-small is-left">
                                        <i className="fas fa-envelope" />
                                    </span>
                                    <span className="icon is-small is-right">
                                        <i className="fas fa-exclamation-triangle" />
                                    </span>
                                </div>
                            </div>

                            <div className="field">
                                <label className="label has-text-white">Message</label>
                                <div className="control">
                                    <textarea className="textarea" name="message" id="message" />
                                </div>
                            </div>

                            <div className="control">
                                <button className="button is-link is-theme-info has-text-white has-text-weight-semibold" type="submit">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Footer />

    </Layout>
);

export default ContactPage;
